import { Component } from '@angular/core';
import {ExamenesPeriodicosHeroComponent} from "./examenes-periodicos-hero/examenes-periodicos-hero.component";
import {InfoComponent} from "../home/info/info.component";
import {InfoProcedimientosComponent} from "./info-procedimientos/info-procedimientos.component";
import {FooterPersonaComponent} from "../../app-persona/footer-persona/footer-persona.component";

@Component({
  selector: 'app-examenes-periodicos',
  standalone: true,
    imports: [
        ExamenesPeriodicosHeroComponent,
        InfoComponent,
        InfoProcedimientosComponent,
        FooterPersonaComponent
    ],
  templateUrl: './examenes-periodicos.component.html',
  styleUrl: './examenes-periodicos.component.css'
})
export class ExamenesPeriodicosComponent {


}
